import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

import { cn } from '@/shared/lib/utils';

/**
 * `<input type="checkbox">` nativo, estilizado com `accent-color`.
 *
 * Nativo pelo mesmo motivo do `Select`: já vem com teclado, leitor de tela e
 * área de toque do sistema — e a alternativa custaria dependência nova
 * (regra 13) para ganhar um quadradinho desenhado por nós.
 */
export const Checkbox = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        'size-4 shrink-0 cursor-pointer rounded border-input accent-primary',
        // O recuo no clique é o que o `accent-color` não dá: o desenho do
        // quadradinho é do sistema, o retorno tátil é nosso.
        'transition-transform duration-fast ease-out active:scale-90',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Checkbox.displayName = 'Checkbox';
